export interface EmailTemplate {
  id?: number;
  externalId?: string;
  title: string;
  description: string;
  emailType: EmailTemplateType;
  body: string;
  htmlBody: string;
  isDefault: boolean;
  createdDate?: Date;
  lastModifiedDate?: Date;
  createdByName?: string;
  createdById?: string;
  lastModifiedByName?: string;
  lastModifiedById?: string;
}

export enum EmailTemplateType {
  CANDIDATE_REJECTION = 'candidate_rejection',
}
